import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[820px] md:min-h-[920px] flex items-center justify-center overflow-hidden bg-background-50">
      <div className="absolute inset-0">
        <img
          src="/images/trilogy/rg-tree.jpg"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/40 via-background-50/15 to-background-50/85" />
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-28 md:pt-36 pb-20">
        <p className="text-xs md:text-sm tracking-[0.25em] uppercase text-foreground-500 mb-5">
          AUM 宇會｜宇宙生命樹文明
        </p>

        <h1
          className="text-3xl md:text-5xl lg:text-6xl leading-tight text-foreground-900 mb-4"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          AUM1001 MATRIX
        </h1>

        <p
          className="text-xl md:text-2xl text-foreground-800 mb-2"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          宇宙生命樹文明入口
        </p>

        <p className="text-sm md:text-base text-foreground-500 mb-8">
          Portal to the Tree of Life
        </p>

        <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto mb-10">
          AUM1001 Matrix 是宇宙生命樹的完整文明架構——不只是《旋轉門》，而是涵蓋書籍、生命實踐、AI
          陪伴與文明共建的整棵生命樹。
        </p>

        {/* START HERE — 第一屏即見的 RG 入口 */}
        <div className="max-w-xl mx-auto rounded-lg border border-primary-300/70 bg-background-50/90 backdrop-blur-sm px-6 md:px-8 py-7">
          <p className="text-xs tracking-[0.25em] uppercase text-primary-700 mb-3 font-medium">
            START HERE｜1001 REVOLVING GATE
          </p>
          <p
            className="text-lg md:text-xl text-foreground-900 mb-2"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            《1001旋轉門》｜目前主要的 5D 實踐入口
          </p>
          <p className="inline-flex items-start gap-1.5 text-xs text-primary-800 bg-primary-100 rounded-2xl px-3 py-2 mb-5 leading-relaxed">
            <i className="ri-calendar-line mt-0.5 shrink-0" />
            嘖嘖募資專案審核中，正式上線日期將於審核通過後公告。
          </p>
          <div>
            <Link
              to="/revolving-gate"
              className="inline-block whitespace-nowrap px-8 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base hover:bg-primary-600 transition-colors cursor-pointer"
            >
              進入《1001旋轉門》
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
